module.exports = __webpack_public_path__ + "img/3.94e021d7.jpg";